// @core/api/endpoints/search/suggest.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SuggestResponse,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Get search suggestions
 * Returns autocomplete suggestions for the given query prefix. Scoped by product and entity type.
 */
export async function Suggest(
  params?: {
    limit?: string | number | boolean;
    q?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<SuggestResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/search/suggest`;
  const requestOptions = options;
  return client.get<SuggestResponse>(requestPath, { ...requestOptions, params });
}
